import { render, staticRenderFns } from "./_workFloNeedsArticles.vue?vue&type=template&id=05335b3a&scoped=true&"
import script from "./_workFloNeedsArticles.vue?vue&type=script&lang=js&"
export * from "./_workFloNeedsArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05335b3a",
  null
  
)

export default component.exports